import React from 'react'
import AppRoutes from './layouts/navigation/AppRoutes'
import { ComponentNavigation } from './layouts/navigation/ComponentNavigation'
import { TaskFilterProvider } from './utils/Context/TaskFilterContext'
import { TaskGroupByProvider } from './utils/Context/TaskGroupByContext'
import AppInitializer from './app/auth/AppInitializer'

const App = () => {
  return (
    <div>
      <AppInitializer />
      <TaskFilterProvider>
        <TaskGroupByProvider>
          <AppRoutes componentRoutes={ComponentNavigation} />
        </TaskGroupByProvider>
      </TaskFilterProvider>
    </div>
  )
}

export default App